// removed by extract-text-webpack-plugin
module.exports = {"image-box":"image-box__3KPic","fundTitle":"fundTitle__11XDU","tabs":"tabs__1EZbx","active":"active__3HQ0k","amount-fund":"amount-fund__3iLqN","p0":"p0__3PoPQ","pb20":"pb20__3WqUT","btn-hollow":"btn-hollow__GpKTV","info":"info__1lEzJ","fund-box":"fund-box__3olbn","fundItem":"fundItem__3uxoY","list-header":"list-header__2sX2g","fund-list":"fund-list__2HVEO","invest-btn":"invest-btn__1e-4s","top-funds-wrapper":"top-funds-wrapper__2sZFv","avatar-parent":"avatar-parent__2gZzj","title":"title__1TXiM","hollow-invest":"hollow-invest__uQjvi","fund-btn-wrapper":"fund-btn-wrapper__3RSp5"};


//////////////////
// WEBPACK FOOTER
// ./styles/homePage/topFunds.scss
// module id = 33
// module chunks = 68